import { io } from "socket.io-client";
froggy.socketio = {
	open_tasks: {},
	open_docs: [],
	emit_queue: [],

	init: function (port = 3000) {
		if (froggy.boot.disable_async) {
			return;
		}

		if (froggy.socketio.socket) {
			return;
		}

		// Enable secure option when using HTTPS
		if (window.location.protocol == "https:") {
			froggy.socketio.socket = io.connect(froggy.socketio.get_host(port), {
				secure: true,
				withCredentials: true,
				reconnectionAttempts: 3,
			});
		} else if (window.location.protocol == "http:") {
			froggy.socketio.socket = io.connect(froggy.socketio.get_host(port), {
				withCredentials: true,
				reconnectionAttempts: 3,
			});
		}

		if (!froggy.socketio.socket) {
			console.log("Unable to connect to " + froggy.socketio.get_host(port));
			return;
		}

		froggy.socketio.socket.on("msgprint", function (message) {
			froggy.msgprint(message);
		});

		froggy.socketio.socket.on("progress", function (data) {
			if (data.progress) {
				data.percent = (flt(data.progress[0]) / data.progress[1]) * 100;
			}
			if (data.percent) {
				froggy.show_progress(
					data.title || __("Progress"),
					data.percent,
					100,
					data.description,
					true
				);
			}
		});

		froggy.socketio.setup_listeners();
		froggy.socketio.setup_reconnect();

		$(document).on("form-load form-rename", function (e, frm) {
			if (!frm.doc || frm.is_new()) {
				return;
			}

			for (var i = 0, l = froggy.socketio.open_docs.length; i < l; i++) {
				var d = froggy.socketio.open_docs[i];
				if (frm.doctype == d.doctype && frm.docname == d.name) {
					// already subscribed
					return false;
				}
			}

			froggy.socketio.doc_subscribe(frm.doctype, frm.docname);
		});

		$(document).on("form-refresh", function (e, frm) {
			if (!frm.doc || frm.is_new()) {
				return;
			}

			froggy.socketio.doc_open(frm.doctype, frm.docname);
		});

		$(document).on("form-unload", function (e, frm) {
			if (!frm.doc || frm.is_new()) {
				return;
			}

			// froggy.socketio.doc_unsubscribe(frm.doctype, frm.docname);
			froggy.socketio.doc_close(frm.doctype, frm.docname);
		});

		$(document).on("form-typing", function (e, frm) {
			froggy.socketio.form_typing(frm.doctype, frm.docname);
		});

		$(document).on("form-stopped-typing", function (e, frm) {
			froggy.socketio.form_stopped_typing(frm.doctype, frm.docname);
		});

		window.addEventListener("beforeunload", () => {
			if (!cur_frm || !cur_frm.doc || cur_frm.is_new()) {
				return;
			}

			froggy.socketio.doc_close(cur_frm.doctype, cur_frm.docname);
		});
	},
	get_host: function (port = 3000) {
		var host = window.location.origin;
		if (window.dev_server) {
			var parts = host.split(":");
			port = froggy.boot.socketio_port || port.toString() || "3000";
			if (parts.length > 2) {
				host = parts[0] + ":" + parts[1];
			}
			host = host + ":" + port;
		}
		return host;
	},
	subscribe: function (task_id, opts) {
		// TODO DEPRECATE

		froggy.socketio.socket.emit("task_subscribe", task_id);
		froggy.socketio.socket.emit("progress_subscribe", task_id);

		froggy.socketio.open_tasks[task_id] = opts;
	},
	task_subscribe: function (task_id) {
		froggy.socketio.socket.emit("task_subscribe", task_id);
	},
	task_unsubscribe: function (task_id) {
		froggy.socketio.socket.emit("task_unsubscribe", task_id);
	},
	doctype_subscribe: function (doctype) {
		froggy.socketio.socket.emit("doctype_subscribe", doctype);
	},
	doctype_unsubscribe: function (doctype) {
		froggy.socketio.socket.emit("doctype_unsubscribe", doctype);
	},
	doc_subscribe: function (doctype, docname) {
		if (froggy.flags.doc_subscribe) {
			console.log("throttled");
			return;
		}

		froggy.flags.doc_subscribe = true;

		// throttle to 1 per sec
		setTimeout(function () {
			froggy.flags.doc_subscribe = false;
		}, 1000);

		froggy.socketio.socket.emit("doc_subscribe", doctype, docname);
		froggy.socketio.open_docs.push({ doctype: doctype, docname: docname });
	},
	doc_unsubscribe: function (doctype, docname) {
		froggy.socketio.socket.emit("doc_unsubscribe", doctype, docname);
		froggy.socketio.open_docs = $.filter(froggy.socketio.open_docs, function (d) {
			if (d.doctype === doctype && d.name === docname) {
				return null;
			} else {
				return d;
			}
		});
	},
	doc_open: function (doctype, docname) {
		// notify that the user has opened this doc, if not already notified
		if (
			!froggy.socketio.last_doc ||
			froggy.socketio.last_doc[0] != doctype ||
			froggy.socketio.last_doc[1] != docname
		) {
			froggy.socketio.socket.emit("doc_open", doctype, docname);

			froggy.socketio.last_doc &&
				froggy.socketio.doc_close(
					froggy.socketio.last_doc[0],
					froggy.socketio.last_doc[1]
				);
		}
		froggy.socketio.last_doc = [doctype, docname];
	},
	doc_close: function (doctype, docname) {
		// notify that the user has closed this doc
		froggy.socketio.socket.emit("doc_close", doctype, docname);

		// if the doc is closed the user has also stopped typing
		froggy.socketio.socket.emit("doc_typing_stopped", doctype, docname);
	},
	form_typing: function (doctype, docname) {
		// notifiy that the user is typing on the doc
		froggy.socketio.socket.emit("doc_typing", doctype, docname);
	},
	form_stopped_typing: function (doctype, docname) {
		// notifiy that the user has stopped typing
		froggy.socketio.socket.emit("doc_typing_stopped", doctype, docname);
	},
	setup_listeners: function () {
		froggy.socketio.socket.on("task_status_change", function (data) {
			froggy.socketio.process_response(data, data.status.toLowerCase());
		});
		froggy.socketio.socket.on("task_progress", function (data) {
			froggy.socketio.process_response(data, "progress");
		});
	},
	setup_reconnect: function () {
		// subscribe again to open_tasks
		froggy.socketio.socket.on("connect", function () {
			// wait for 5 seconds before subscribing again
			// because it takes more time to start python server than nodejs server
			// and we use validation requests to python server for subscribing
			setTimeout(function () {
				$.each(froggy.socketio.open_tasks, function (task_id, opts) {
					froggy.socketio.subscribe(task_id, opts);
				});

				// re-connect open docs
				$.each(froggy.socketio.open_docs, function (d) {
					if (locals[d.doctype] && locals[d.doctype][d.name]) {
						froggy.socketio.doc_subscribe(d.doctype, d.name);
					}
				});

				if (cur_frm && cur_frm.doc && !cur_frm.is_new()) {
					froggy.socketio.doc_open(cur_frm.doc.doctype, cur_frm.doc.name);
				}
			}, 5000);
		});
	},
	process_response: function (data, method) {
		if (!data) {
			return;
		}

		// success
		var opts = froggy.socketio.open_tasks[data.task_id];
		if (opts[method]) {
			opts[method](data);
		}

		// "callback" is std froggy term
		if (method === "success") {
			if (opts.callback) opts.callback(data);
		}

		// always
		froggy.request.cleanup(opts, data);
		if (opts.always) {
			opts.always(data);
		}

		// error
		if (data.status_code && data.status_code > 400 && opts.error) {
			opts.error(data);
		}
	},
};

froggy.provide("froggy.realtime");
froggy.realtime.on = function (event, callback) {
	froggy.socketio.socket && froggy.socketio.socket.on(event, callback);
};

froggy.realtime.off = function (event, callback) {
	froggy.socketio.socket && froggy.socketio.socket.off(event, callback);
};

froggy.realtime.publish = function (event, message) {
	if (froggy.socketio.socket) {
		froggy.socketio.socket.emit(event, message);
	}
};
